/**
 * Created by noOne on 13/12/2017.
 */
"use strict";

import Common from "./Common";
import GlitchFilter from "./GlitchFilter";
import ScanlinesFilter from "./ScanlinesFilter";

export default class IntroScene extends P3.Scene {
    constructor() {
        super();

        this._backHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._primaryHolder = new PIXI.Container();

        /**
         * @type {PIXI.Container}
         * @private
         */
        this._loadingHolder = new PIXI.Container();

        /**
         * @type {ScanlinesFilter}
         * @private
         */
        this._scanLineFilter = null;

        /**
         * @type {PIXI.Text}
         * @private
         */
        this._loadTextView = createText("", {size: 45, fill: 0xffffff, letterSpacing: 15}, "Munro");
    }

    init() {

        const bg = P3.createSprite("splash_bg", this._primaryHolder);
        bg.visible = false;

        this._scanLineFilter = new ScanlinesFilter(bg);

        let frontHolder = new PIXI.Container();

        this.addChild(this._backHolder, this._primaryHolder, frontHolder);
        this._primaryHolder.addChild(this._loadingHolder);

        this._skipBtn = P3.simpleButton("small", "next", ()=> {
            // this.animateOut();
            this.end();
        }, this);
        frontHolder.addChild(this._skipBtn);

        this.start();
    }

    start() {

        const spine = P3.createSpine("intro", "animation", true, false);
        this._primaryHolder.addChild(spine);
        spine.x = Common.STAGE_WIDTH * 0.5;
        spine.y = P3.View.height * 0.5;

        delay(()=> {
            spine.visible = false;
            this.bootSequence();
        }, 10, this);


        Common.audio.stopMusic();
        Common.audio.playMusic("music_menu_loop_00");
    }

    /**
     * @deprecated
     */
    headsetAnimation() {

        this._goggles = P3.createSprite("vr_goggles", this._primaryHolder);
        this._goggles.anchor.set(0.5, 0.25);
        this._goggles.position.set(Common.STAGE_WIDTH * 0.5, -this._goggles.height * 0.5);
        TweenMax.to(this._goggles, 1, {
            y: P3.View.height * 0.5,
            onComplete: ()=> {
                TweenMax.to(this._goggles.scale, 0.5, {
                    x: 8,
                    y: 8
                });
                TweenMax.to(this._goggles, 0.5, {
                    alpha: 0
                });

                delay(()=> {
                    this.bootSequence();
                }, 0.4, this);
            }
        });
    }

    bootSequence() {

        const overlay = P3.createSprite(PIXI.Texture.WHITE, this._primaryHolder);
        overlay.anchor.set(0);
        overlay.width = Common.STAGE_WIDTH;
        overlay.height = P3.View.height;
        overlay.tint = 0x0;

        TweenMax.to(overlay, 0.15, {alpha: 0, ease: Power0.easeNone});

        this._primaryHolder.filters = [this._scanLineFilter];
        let typeView = createText("_", {size: 45, fill: 0xffffff, stroke: 0xFFFFF0, strokeThickness: 2}, "Munro");
        TweenMax.to(typeView, 0.25, {alpha: 0, ease: Sine.easeInOut, yoyo: true, repeat: -1});
        typeView.y = -15;
        this._typeView = typeView;

        this._loadingHolder.addChild(typeView);
        this._loadingHolder.y = P3.View.height - 225;

        const loadString = "../FOR X=1 GOTO VR 0.3";
        const loadTextView = this._loadTextView;
        loadTextView.anchor.set(0, 0.5);
        this._loadingHolder.addChild(loadTextView);
        this._loadTextView = loadTextView;
        this._textArray = loadString.split("");

        const title = createText("VR 0.3 BETA", {
            size: 175,
            fill: 0xffffff,
            stroke: 0x93DB70,
            strokeWidth: 8
        }, "Digital-7");
        title.x = Common.STAGE_WIDTH * 0.5;
        title.y = P3.View.height * 0.5 - 100;
        title.alpha = 0;
        title.anchor.set(0.5);
        this._primaryHolder.addChild(title);
        this._title = title;

        const pixFilter = new GlitchFilter(15);
        pixFilter.uFreq = Math.random() * 0.001;
        pixFilter.uAmp = Math.random() * 0.002;

        this._typeView.x = this._loadTextView.x;

        //-animate as if someone was typing--//
        for (let i = 0; i < this._textArray.length; i++) {
            delay(()=> {
                this._loadTextView.text += this._textArray[i];
                this._typeView.x = this._loadTextView.x + this._loadTextView.width;
            }, i * 0.05 + 0.5 + (Math.random() / 20 - 0.025), this);
        }

        const delayLength = this._textArray.length * 0.1;
        delay(()=> {
            this.end();
        }, delayLength, this);

    }

    /**
     * @deprecated
     */
    animateScreen() {

        let blue = P3.createSprite(PIXI.Texture.WHITE, this._backHolder);
        blue.tint = 0xA0A0A0;
        blue.anchor.set(0.5);
        blue.width = Common.STAGE_WIDTH;
        blue.height = P3.View.height;
        blue.x = Common.STAGE_WIDTH * 0.5;
        blue.y = P3.View.height * 0.5;

        let redContainer = new PIXI.Container();

        this._backHolder.addChild(redContainer);

        TweenMax.to(redContainer, 1, {y: -150, repeat: -1, ease: Power0.easeNone});

        for (let i = 0; i < 10; i++) {

            let red = P3.createSprite(PIXI.Texture.WHITE, redContainer);
            red.anchor.set(0.5);
            red.width = Common.STAGE_WIDTH;
            red.height = 75;
            //  red.tint = 0xc80000;
            red.tint = 0x484848;

            red.rotation = -0.01;

            red.x = Common.STAGE_WIDTH * 0.5;
            red.y += i * 150;
        }

        let white = P3.createSprite(PIXI.Texture.WHITE, this._backHolder);
        white.tint = 0x0;//is now black
        white.width = P3.View.width - 150;
        white.height = P3.View.height - 150;
        white.anchor.set(0.5);
        white.x = Common.STAGE_WIDTH * 0.5;
        white.y = P3.View.height * 0.5;

        delay(()=> {
            this.end();
        }, 2.5, this);
    }

    appear() {

    }

    animateOut() {

    }

    end() {
        this._running = false;
        Common.audio.stopMusic();
        this.signals.next.dispatch(this);
    }

    update() {
        this._scanLineFilter.uniforms.time += deltaTime;
    }

    destroy() {
        TweenMax.killAll();
        super.destroy({children: true});
        Common.audio.stopMusic();
    }

    resize() {
        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
        this._loadTextView.x = (Common.STAGE_WIDTH - P3.View.width) * 0.5 + 55;//lhs
        this._skipBtn.x = (Common.STAGE_WIDTH + P3.View.width) * 0.5 - 55;
        this._skipBtn.y = P3.View.height - 55;
    }
}

